import { NavLink } from "react-router";
import number_format from "../../utils/number_format";
import { PartnerApi } from "../../api/partner.api";
import { useTranslation } from "../../hooks/useTranslation";

export default function OpportunityRow({
  awailableColumns,
  selectedColumns,
  opportunity,
  checkbox,
  showCompanyDetail,
}) {
  const { t } = useTranslation();
  return (
    <tr>
      {false && checkbox === true && (
        <td>
          <div className="form-check form-check-sm form-check-custom form-check-solid">
            <input
              className="form-check-input"
              type="checkbox"
              value={opportunity.opportunity_id}
              onChange={(e) => console.log(e.target.value)}
            />
          </div>
        </td>
      )}
      {Object.keys(awailableColumns)
        .filter((awailableColumnsKey) =>
          selectedColumns.includes(awailableColumnsKey)
        )
        .map((awailableColumnsKey, index) => (
          <td
            key={awailableColumnsKey}
            className={
              ["purchase_total_amount_local_currency"].includes(
                awailableColumnsKey
              ) && "text-end"
            }
          >
            {["opportunity_number", "issued_by"].includes(
              awailableColumnsKey
            ) && opportunity[awailableColumnsKey]}
            {["create_date", "opportunity_date", "invoice_date"].includes(
              awailableColumnsKey
            ) &&
              (opportunity[awailableColumnsKey]
                ? new Date(
                    opportunity[awailableColumnsKey]
                  ).toLocaleDateString()
                : "-")}

            {"opportunity_id" == awailableColumnsKey && (
              <>
                <NavLink to={"/prilezitost/" + opportunity.opportunity_id}>
                  {opportunity.opportunity_id}
                </NavLink>
                {opportunity.vendors && opportunity.vendors[0] && (
                  <>
                    <div>
                      <span
                        className={
                          "badge badge-secondary mt-3 badge-vendor-" +
                          opportunity.vendors[0].vendor_id
                        }
                      >
                        {opportunity.vendors[0].name}
                      </span>
                    </div>
                    <img
                      className="mw-100 mt-5 d-none"
                      xstyle={{
                        aspectRatio: "1 / 1",
                        objectFit: "contain",
                      }}
                      src={
                        PartnerApi.url +
                        "/vendor/" +
                        opportunity.vendors[0].vendor_id +
                        "/logo.jpg"
                      }
                      alt={opportunity.vendors[0].name}
                    />
                  </>
                )}
              </>
            )}

            {"description" == awailableColumnsKey && (
              <>
                <NavLink to={"/prilezitost/" + opportunity.opportunity_id}>
                  {opportunity.description}
                </NavLink>
              </>
            )}
            {"current_state" == awailableColumnsKey && (
              <>{opportunity.current_state?.state_name}</>
            )}
            {"exn_person" == awailableColumnsKey && (
              <>
                {opportunity.exn_person?.first_name}
                &nbsp;
                {opportunity.exn_person?.last_name}
              </>
            )}
            {"sales_person" == awailableColumnsKey && (
              <>
                {opportunity.sales_person?.first_name}
                &nbsp;
                {opportunity.sales_person?.last_name}
              </>
            )}
            {"end_customer" == awailableColumnsKey && (
              <>
                <a
                  href={"/klient/" + opportunity.end_customer?.company_id}
                  onClick={(e) => {
                    showCompanyDetail &&
                      showCompanyDetail(opportunity.end_customer?.company_id);
                    e.preventDefault();
                  }}
                >
                  {opportunity.end_customer?.name}
                </a>
              </>
            )}

            {"purchase_total_amount_local_currency" == awailableColumnsKey &&
              (opportunity.purchase_total_amount_local_currency !== "n/a" ? (
                <>
                  {number_format(
                    opportunity.purchase_total_amount_local_currency,
                    2,
                    ",",
                    "."
                  )}
                  &nbsp;
                  {opportunity.local_currency}
                  {opportunity.local_currency !==
                    opportunity.purchase_currency && (
                    <div>
                      <span className="badge badge-warning">
                        {t("opportunities.invoicingIn")} {opportunity.purchase_currency}
                      </span>
                    </div>
                  )}
                </>
              ) : (
                <div className="badge badge-secondary">{t("opportunities.hidden")}</div>
              ))}
          </td>
        ))}

      <td className="text-end">
        <NavLink
          className="btn btn-primary btn-sm"
          to={"/prilezitost/" + opportunity.opportunity_id}
        >
          {t("common.detail")}
        </NavLink>
      </td>
    </tr>
  );
}
